import { Component, OnInit, Input } from '@angular/core';

export interface IconeTituloData {
  icon: string;
  highlightText: string;
}

@Component({
  selector: 'fcp-icone-titulo',
  templateUrl: './icone-titulo.component.html',
  styleUrls: ['./icone-titulo.component.scss']
})
export class IconeTituloComponent implements OnInit {
  @Input() public iconeTitulo: IconeTituloData;

  constructor() { }

  ngOnInit(): void {
  }

}
